import { createGlobalStyle } from 'styled-components'
import tegelCss from '@scania/tegel/dist/tegel/tegel.css'

export const GlobalStyle = createGlobalStyle`
${tegelCss}

h1,
h2,
h3,
h4,
h5 {
  margin: 0;
}

html,
  body {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: 0px;

    // Disallow scrolling.
    overflow: hidden;
  }
*,
*:before,
*:after {
  box-sizing: inherit;
}

#root {
  height: 100%;
  position: fixed;
  top: 0px;
}

:root {
  /* General variables and constants */
  --header-height: 64px;
  --configurator-menu-width: 288px;

  /* TODO: Merge into one? */
  --footer-height: 48px;
  --footer-height-mobile: 250px;
}
`
